export default __webpack_public_path__ + "static/bariol_serif_bold-webfont-6167290e40eb7067e56a03fda24b17aa.ttf";